import { render } from "./A5Data.vue?vue&type=template&id=7bce19ce&scoped=true"
import script from "./A5Data.vue?vue&type=script&lang=js"
export * from "./A5Data.vue?vue&type=script&lang=js"

import "./A5Data.vue?vue&type=style&index=0&id=7bce19ce&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bce19ce"]])

export default __exports__